import React ,{useState,useEffect} from 'react';
import {useSelector,useDispatch} from 'react-redux';
import {Box,Typography,Paper,Button,makeStyles} from '@material-ui/core';
import {useHistory} from 'react-router-dom';

import {playersList} from '.././utils/players';
import {filterData,refactorPlayers} from '../actions/match';
import Message from './message/Message';


const useStyles=makeStyles({
    root:{
        minHeight:'100vh',
        background:'linear-gradient(to bottom right,rgba(33, 9, 78,0.6),#4CA1A3,rgba(81, 18, 129,0.6),#45E1AD)',
    },
    title:{
        fontSize:'40px',
        marginLeft:'50px',
        color:'#fff',
        flexBasis:'80%'
    },
    topBar:{
        display: 'flex',
        alignItems:'center',
        padding:'30px'
    },
    credits:{
        display: 'flex',
        alignItems:'center',
        "& span":{
            fontSize:'30px',
            color:'#fff'
        }
    },
    playersContainer:{
        padding:'0 20px',
        display:'grid',
        gridTemplateColumns:'repeat(auto-fit,minmax(40%,1fr))',
        gridGap:'30px'
    },
    player:{
        display: 'flex',
        alignItems:'center',
        justifyContent:'space-evenly',
        padding:'10px'
    },
    btnSelect:{
       color: '#4CA1A3',
       fontWeight:'bold',
       "&:hover":{
           background: '#4CA1A3',
           color:'#fff'
       }
    },
    btnCptn:{
        background: 'rgba(81, 18, 129,0.5)',
        fontWeight:'bold',
        "&:hover":{
            background: 'rgba(81, 18, 129,0.5)',
            color:'#fff'
        }
    },
    btnVcptn:{
        background: 'rgba(33, 9, 78,0.5)',
        fontWeight:'bold',
        "&:hover":{
            background: 'rgba(33, 9, 78,0.5)',
            color:'#fff'
        }
    },
    btnContainer:{
        display: 'flex',
        justifyContent:'center',
        padding:'25px'
    },
    btnCtn:{
        background:'linear-gradient(to top left,#4CA1A3,#45E1AD)',
        color:'#fff',
        "&:hover":{
            background: 'rgba(81, 18, 129,0.5)'
        }
    }
})

const Player = () => {
   
    const dispatch=useDispatch();
    const history=useHistory();
    const classes=useStyles();

    const match=useSelector((state)=>state.selectedMatch);
    const rawPlayers=useSelector((state)=>state.players);
    const players=useSelector((state)=>state.selectedPlayers.players);
    console.log("players",players)

    const [score,setScore]=useState(100);
    const [showMsg,setShowMsg]=useState(false);
    const [msg,setMsg]=useState("");
    const [color,setColor]=useState("green");

    useEffect(()=>{
        const filteredData=playersList(match,rawPlayers);
        dispatch(filterData(filteredData))
    },[])

    const selectHandle=(player)=>{
        const numOfSel=players.filter((p)=>p.role==="p" || p.role==="c" || p.role==="vc");
        if(numOfSel.length===11){
            setMsg("maximum number of players are 11");
            setColor("red");
            setShowMsg(true)
            return //maximum number of players are 11 
        }
        if(score<player.score){
            setMsg("You don't have sufficent points to select this player");
            setColor("red");
            setShowMsg(true)
            return; //u dont have sufficent points to select this player
        }
        const selPlayer=players.find((p)=>p.player===player.player);
        if(!selPlayer){
            return;
        }
         if(selPlayer.role==="p"){
            setMsg("cannot select a player twice");
            setColor("red");
            setShowMsg(true)
             return;  //cannot select a player twice
         }
         selPlayer.role="p";
         setScore(score-selPlayer.score);
    }

    const selectCaptainHandler=(player,role)=>{
        const selPlayer=players.find((p)=>p.player===player.player);
        const captain=players.find((p)=>p.role==="c");
        const vCaptain=players.find((p)=>p.role==="vc");
       // console.log("selplayer",selPlayer)
        if(!selPlayer){
            return;
        }
        console.log("sele",selPlayer)
        if(!selPlayer.role){
            setMsg("A player should be selected before making him captain or vicecaptain");
            setColor("red");
            setShowMsg(true)
            return;  //console.log("A player should be selected before making him captain or vicecaptain")
        }
        if(captain && role==="c"){
            setMsg("cannot make more than one captain");
            setColor("red");
            setShowMsg(true)
            return //cannot make more than one captain 
        }
        if(vCaptain && role==="vc"){
            setMsg("cannot make more than one vicecaptain");
            setColor("red");
            setShowMsg(true)
            return //cannot make more than one vicecaptain
        }
        if((selPlayer.role==="vc" && role==="c") || (selPlayer.role==="c" && role==="vc")){
            setMsg("same person cannot be captain and vicecaptain");
            setColor("red");
            setShowMsg(true)
            return; //console.log("same person cannot be captain and vicecaptain")
        }
        selPlayer.role=role;
    }

    const submitHandle=()=>{
        const numOfPlayers=players.filter((p)=>p.role==="p" || p.role==="c" || p.role==="vc");
        console.log(numOfPlayers)
        if(numOfPlayers.length!==11){
            setMsg("There should be 11 players in the team");
            setColor("red");
            setShowMsg(true)
            return //there should be 11 players in the team
        }
        const captain=players.find((p)=>p.role==="c");
        const vCaptain=players.find((p)=>p.role==="vc");
        if(!captain){
            setMsg("captain should be there");
            setColor("red");
            setShowMsg(true)
            return; // captain should be there
        }
        if(!vCaptain){
            setMsg("A team should contain a vicecaptain");
            setColor("red");
            setShowMsg(true)
            return //A team should contain a vicecaptain
        }
        console.log(" final players",players);
        dispatch(refactorPlayers(players));
        sessionStorage.setItem("score",JSON.stringify(score));
        history.push("/startMatch");
    }


   if(!players || !players?.length>0){
       return <h1>Loading...</h1>
   }
   return (
       <Box component="div" className={classes.root}>
          <Box component="div" className={classes.topBar}>
              <Typography variant="h1" align="center" className={classes.title}>Create team</Typography>
              <Typography variant="body2" className={classes.credits}>Your credits : 
                <span>{score}</span>
              </Typography>
          </Box>
          <Box component="div" className={classes.playersContainer}>
          {
               players.map((player)=>{
                return <Paper className={classes.player}>
                      <Typography variant="h6" style={{flexBasis:'35%'}}>{player.player}</Typography>
                      <Button  size="small" disabled={player.role?true:false} onClick={()=>selectHandle(player)} className={classes.btnSelect}>Select</Button>
                      <Button  size="small" disabled={player.role?false:true && player.role==="vc"?true:false} onClick={()=>selectCaptainHandler(player,"c")} className={classes.btnCptn}>C</Button>
                      <Button  size="small" disabled={player.role?false:true && player.role==="c"?true:false} onClick={()=>selectCaptainHandler(player,"vc")} className={classes.btnVcptn}>VC</Button>
                      <Typography variant="h5" style={{flexBasis:'8%'}}>{player.score}</Typography>
                </Paper>
            })
         }
          </Box>
         <Box className={classes.btnContainer}>
           <Button variant="contained" onClick={submitHandle} className={classes.btnCtn}>Continue</Button>
         </Box>
        {showMsg?<Message color={color} message={msg} setShowMsg={setShowMsg}/>:null}
       </Box>
   )
}

export default Player
